
import React from "react";

const testimonials = [
  {
    content: "Os prompts específicos para petições iniciais trabalhistas economizaram horas do meu tempo e melhoraram significativamente a qualidade das minhas minutas.",
    author: "Dra. Mariana Costa",
    role: "Advogada Trabalhista",
    avatar: "/decidedigital-uploads/b359a4e6-8e2e-4f2a-afaf-0ccd30eac139.png"
  },
  {
    content: "Consegui aumentar minha produtividade em 40% utilizando os prompts de contratos. A plataforma facilita muito o trabalho com IA para advogados.",
    author: "Dr. Ricardo Mendes",
    role: "Especialista em Direito Contratual",
    avatar: "/decidedigital-uploads/10104749-bc9d-47b5-b0a9-969ef6eeb575.png"
  },
  {
    content: "A relação custo-benefício é incrível. Os prompts já estruturados me poupam tempo de tentativa e erro com ferramentas de IA.",
    author: "Dra. Paula Vieira",
    role: "Advogada Cível",
    avatar: "/decidedigital-uploads/08798447-90f0-4fdb-99fc-f49e7ae305dd.png"
  }
];

const Testimonials = () => {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold font-display mb-4">O que dizem nossos usuários</h2>
          <p className="text-gray-600 max-w-xl mx-auto">
            Centenas de advogados já utilizam nossos prompts para otimizar seu fluxo de trabalho.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index} 
              className="bg-white rounded-lg p-6 shadow-md border border-gray-100 flex flex-col card-hover"
            >
              <div className="flex-grow">
                <p className="text-gray-600 italic mb-6">"{testimonial.content}"</p>
              </div>
              <div className="flex items-center">
                <img 
                  src={testimonial.avatar} 
                  alt={testimonial.author} 
                  className="w-12 h-12 rounded-full mr-4 object-cover"
                />
                <div>
                  <p className="font-semibold text-lawyer-primary">{testimonial.author}</p>
                  <p className="text-gray-500 text-sm">{testimonial.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
